import type {ValueOf} from '@myparcel-frontend/types';
import {TierName} from '@/types/subscriptions/tiers';

export const MyReturnsProductId = {
  Max: 1234,
} as const;

export const MyReturnsTierName = {
  Max: TierName.Max,
} as const;

export const MY_RETURNS_IDS_TO_NAMES = {
  [MyReturnsProductId.Max]: MyReturnsTierName.Max,
};

export const MY_RETURNS_NAMES_TO_IDS = {
  [MyReturnsTierName.Max]: MyReturnsProductId.Max,
};

export const toMyReturnsTierName = <T extends ValueOf<typeof MyReturnsProductId>>(id: T) => {
  return MY_RETURNS_IDS_TO_NAMES[id];
};

export const toMyReturnsProductId = <T extends ValueOf<typeof MyReturnsTierName>>(name: T) => {
  return MY_RETURNS_NAMES_TO_IDS[name];
};
